import { Button as ButtonAntd, Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const Button = styled(ButtonAntd).attrs({
  type: 'link',
})`
  border-radius: 2px !important;
  border: transparent;
  background: none;
  color: #24a95d;
  padding: 4px 0;

  &:hover {
    color: #39c05b;
    border: none;
  }
`;

export const TextLink = styled(Text)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #24a95d;
`;
